import { render, staticRenderFns } from "./ChooseTemplate.vue?vue&type=template&id=067a0fd2&scoped=true"
import script from "./ChooseTemplate.vue?vue&type=script&lang=js"
export * from "./ChooseTemplate.vue?vue&type=script&lang=js"
import style0 from "./ChooseTemplate.vue?vue&type=style&index=0&id=067a0fd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067a0fd2",
  null
  
)

export default component.exports